import type { ICaseNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createCaseNote,
  updateNote: updateCaseNote,
  deleteNote: deleteCaseNote,
} = makeNoteService<ICaseNote>('/api/casenotes', 'caseNote')
